import { Injectable } from "@angular/core";

/**订阅SignalR时 管理员与项目人员 订阅项目Id工具类  主要是防止项目人员传输根节点项目Id到SignalR后台 且后台无权限过滤的问题*/
@Injectable({
    providedIn: 'root'
})
export class SubscribeProjectId {
    constructor() {

    }

}
